<template>
  <article class="kds-quote-card">
    <header class="kds-quote-card__header">
      <KdsAvatar :segment="segment" :size="40" :speaking="speaking" />
      <div class="kds-quote-card__id">
        <span class="kds-quote-card__name">{{ personaName }}</span>
        <span class="kds-quote-card__code">{{ personaId }}</span>
      </div>
      <KdsBadge v-if="speaking" tone="live">Speaking</KdsBadge>
    </header>
    <blockquote class="kds-quote-card__quote">
      <slot>{{ quote }}</slot>
    </blockquote>
  </article>
</template>

<script setup lang="ts">
import KdsAvatar from '@/kds/primitives/KdsAvatar.vue';
import KdsBadge from '@/kds/primitives/KdsBadge.vue';
import type { PersonaSegment } from '@/kds/types';

interface Props {
  personaName: string;
  personaId: string;
  segment: PersonaSegment;
  quote: string;
  speaking?: boolean;
}

withDefaults(defineProps<Props>(), { speaking: false });
</script>

<style scoped lang="scss">
.kds-quote-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  background: var(--paper);
  border-radius: var(--r-4);
  border: var(--border);
  box-shadow: var(--shadow-2);
  max-width: 320px;

  &__header {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: var(--space-3);
  }

  &__id {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__name {
    font-size: var(--fs-h3);
    color: var(--ink);
  }

  &__code {
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    color: var(--stone);
  }

  &__quote {
    margin: 0;
    font-family: var(--font-serif);
    font-size: 18px;
    line-height: 1.4;
    color: var(--ink);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
